// ── LEGACY — grp_OKTA_DMG_* short names (DELETE after migration cutover) ──────
/** @deprecated Use DamageRoles after migration */
export enum Roles {
  DAMAGE_ADMIN = 'dmg_admin',
  VP_FLEET = 'vp_fleet',
  DM = 'dm',
  RMM = 'rmm',
  BRANCH_MANAGER = 'bm',
  BRANCH_MANAGER_ASSISTANT = 'bm_assist',
  SHOP_SUPERVISOR = 'shop_sup',
  DAMAGE_DESIGNEE = 'dmg_designee',
  EQUIPMENT_COORDINATOR = 'eq_coord',
  MECHANICS = 'mech',
  SALES_AND_OPERATIONS_COORDINATOR = 'sales_op_coord',
  PRO_SALES_ASSOCIATES = 'pro_sales_assoc',
  SALES_REPS = 'sales_reps',
  DAMAGE_FCS_TEAM = 'dmg_fcs_team',
  CUSTOMER_CARE = 'cast_care',
  FLEET_PRODUCT_SUPPORT = 'fleet_prod_sup',
}

// ── NEW PERMISSION SYSTEM — role_id values from role_definition DynamoDB table ─
export enum DamageRoles {
  SYSTEM_ADMIN    = 'system_admin',
  ADMIN           = 'admin',
  TIER_3_APPROVER = 'tier_3_approver',
  TIER_2_APPROVER = 'tier_2_approver',
  TIER_1_APPROVER = 'tier_1_approver',
  READ_WRITE      = 'read_write',
  READ_ONLY       = 'read_only',
}
